export const CLASS_ROOT = "footer";

export const CLASS_CONTAINER = `${CLASS_ROOT}__container`;
export const CLASS_LOGO = `${CLASS_ROOT}__logo`;
export const CLASS_TITLE = `${CLASS_ROOT}__title`;
export const CLASS_LIST = `${CLASS_ROOT}__list`;
export const CLASS_LIST_SPACE_SMALL = `${CLASS_ROOT}__list--space-small`;
export const CLASS_LIST_INLINE = `${CLASS_ROOT}__list--inline`;
export const CLASS_LIST_STACK_SM_DOWN = `${CLASS_ROOT}__list--stack-sm-down`;
export const CLASS_LIST_BREAK_SM_DOWN = `${CLASS_ROOT}__list-break--sm-down`;
export const CLASS_LIST_ITEM_LEAD = `${CLASS_ROOT}__list-item--lead`;
export const CLASS_BOTTOM = `${CLASS_ROOT}__bottom`;
export const CLASS_BOTTOM_COPYRIGHT = `${CLASS_ROOT}__bottom-copyright`;
export const CLASS_MENU = `${CLASS_ROOT}__menu`;
export const CLASS_MENU_SECTION = `${CLASS_ROOT}__menu-section`;
export const CLASS_BAR = `${CLASS_ROOT}__bar`;
export const CLASS_MB_LARGE = `${CLASS_ROOT}--mb-xlarge`;
export const CLASS_ACCORDION_TOGGLE = `${CLASS_ROOT}__accordion-toggle`;
export const CLASS_ACCORDION_ICON = `${CLASS_ROOT}__accordion-icon`;
export const CLASS_DIVIDER = `${CLASS_ROOT}__divider`;
export const CLASS_DIVIDER_HIDE_XS_DOWN = `${CLASS_DIVIDER}--hide-xs-down`;
